import angular from 'angular';

import ForgotPasswordResetComponent from './forgot-password-reset.cmpt';

export default angular
    .module('application.scene.identity.scene.forgot-password-reset', [])
    .component(ForgotPasswordResetComponent.selector, ForgotPasswordResetComponent)
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider, $transitionsProvider) {
    $stateProvider.state('identity.forgot-password.reset', {
        url: '/reset?token',
        template: '<db-a-forgot-password-reset class="block-component"></db-a-forgot-password-reset>'
    });

    // TODO: prevent triggering on start twice
    $transitionsProvider.onStart({
        to: 'identity.forgot-password.reset'
    }, (transition) => {
        const $state = transition.injector().get('$state');
        const resetPasswordService = transition.injector().get('resetPasswordService');

        let params = transition.params() || {};

        if (params.token) {
            return resetPasswordService.validate(params.token).then(() => true, redirect);
        }

        return redirect();

        function redirect() {
            return $state.target('identity.forgot-password.token-expired');
        }
    });
}



// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/forgot-password/scene/forgot-password-reset/index.js